import createIcon from '../../createIcon';

/**
 * @component @name Note
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTBMMTYgNEg0QzIuOSA0IDIgNC45IDIgNlYxOC4wMUMyIDE5LjExIDIuOSAyMCA0IDIwTDIwIDE5Ljk5QzIxLjEgMTkuOTkgMjIgMTkuMSAyMiAxOFYxMFpNMTUgNS41TDIwLjUgMTFIMTVWNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Note = createIcon('Note', [
  [
    'path',
    {
      d: 'M22 10L16 4H4C2.9 4 2 4.9 2 6V18.01C2 19.11 2.9 20 4 20L20 19.99C21.1 19.99 22 19.1 22 18V10ZM15 5.5L20.5 11H15V5.5Z',
      key: '1rfdtl',
    },
  ],
]);

export default Note;
